import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <span>Copyright 2023 © CBU</span>
    </div>
  );
};

export default Footer;
